import { useState } from "react";
import { format, parseISO } from "date-fns";
import { CalendarDays } from "lucide-react";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

const toISO = (d) => format(d, "yyyy-MM-dd");
const endOfToday = () => { const d = new Date(); d.setHours(23, 59, 59, 999); return d; };

export const PaidCalendar = ({ value, onChange, testId }) => (
  <div className="rounded-xl border border-slate-200 bg-white" data-testid={testId}>
    <Calendar
      mode="single"
      selected={value ? parseISO(value) : undefined}
      defaultMonth={value ? parseISO(value) : new Date()}
      onSelect={(d) => d && onChange(toISO(d))}
      disabled={{ after: endOfToday() }}
      toDate={endOfToday()}
      classNames={{ day_selected: "bg-ccc-blue text-white hover:bg-ccc-blue2 focus:bg-ccc-blue rounded-md", day_today: "border border-ccc-blue text-ccc-navy rounded-md" }}
    />
  </div>
);

export const DatePickerField = ({ value, onChange, testId }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId} className="mt-1 w-full h-9 px-3 flex items-center justify-between rounded-md border border-input bg-white text-sm text-ccc-navy hover:border-ccc-blue transition-colors">
          {value ? format(parseISO(value), "dd MMM yyyy") : <span className="text-slate-400">Pick a date</span>}
          <CalendarDays className="h-4 w-4 text-ccc-blue" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <PaidCalendar value={value} onChange={(d) => { onChange(d); setOpen(false); }} testId={`${testId}-calendar`} />
      </PopoverContent>
    </Popover>
  );
};
